import RegionWarning from "../../../../contents/docs/advanced/_snippets/region-warning.mdx";
import ProxyWarning from "../../../../contents/docs/advanced/_snippets/proxy-usage-warning.mdx";
import ProxyPathNamesWarning from "../../../../contents/docs/advanced/_snippets/proxy-path-names-warning.mdx";
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  RegionWarning,
  ProxyWarning,
  ProxyPathNamesWarning,
  CalloutBox,
  React
};